import {
    type TextStyle,
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    BarChartSignTooltipDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    row: {
        alignItems: "center",
        flexDirection: "row"
    },
    value: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    name: {
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    iconSizes,
    spaces
}: BarChartSignTooltipDynamicStyleType) => {
    const styles = {
        value: {
            marginStart: spaces.spacingMd
        } as Mutable<TextStyle>,
        row: {
            minHeight: iconSizes.large,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        container: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
